<template>
  <div class="c-value" :class="rootClass">
    <CEllipsis v-if="isLabelEllipsis" class="c-value-label">
      {{ label }}
    </CEllipsis>
    <p v-else class="c-value-label">
      {{ label }}
    </p>
    <span class="c-value-value">
      <CEllipsis>
        <slot>{{ value }}</slot>
      </CEllipsis>
      <CCopyButton v-if="copy && value" :text="value" class="u-ml-1" />
    </span>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import CCopyButton from '@/general/components/CCopyButton.vue';
  import CEllipsis from './CEllipsis.vue';

  const props = defineProps<{
    label: string;
    value?: string | null;
    vertical?: boolean;
    copy?: boolean;
    isLabelEllipsis?: boolean;
  }>();

  const rootClass = computed(() => {
    return {
      'c-value-vertical': props.vertical,
    };
  });
</script>

<style lang="scss">
.c-value {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  justify-content: space-between;
  min-width: 0;

  &-vertical {
    display: block;
  }

  &-label {
    font-weight: $font-weight-medium;
    font-size: 0.875rem;
  }

  &-value {
    min-width: 0;
    display: flex;
    align-items: center;
  }

  &:not(:last-of-type) {
    margin-bottom: 0.5rem;
  }
}
</style>
